import { gql } from '@apollo/client';
import { CORE_TOOL_CATALOG_FIELDS } from './tool-catalog';

export const SEARCH_TOOL_INVENTORIES = gql`
  ${CORE_TOOL_CATALOG_FIELDS}
  query SearchToolInventories($searchInput: SearchInput) {
    searchToolInventories(searchInput: $searchInput) {
      items {
        id
        barCode
        isSerialized
        isLocked
        statusCode
        thInventoryId
        toolCatalogId
        toolRoomId
        projectId
        createdBy
        onHandCount
        limitCount
        isLocked
        onOrderCount
        description
        updatedDate
        updatedBy
        currentlyIssuedToUser {
          id
          firstName
          lastName
        }
        updatedByUser {
          id
          firstName
          lastName
        }
        toolCatalog {
          ...CoreToolCatalogFields
          isLocked
          limitCount
          toolCategory {
            id
            name
            toolType {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export const GET_TOOL_INVENTORY_COUNT = gql`
  query GetToolInventoryCount($searchInput: SearchInput) {
    toolInventoryCountForSearch(searchInput: $searchInput)
  }
`;
export const UPDATE_TOOL_INVENTORY = gql`
  mutation UpdateToolInventory($updateToolInventoryInput: UpdateToolInventoryInput!) {
    updateToolInventory(updateToolInventoryInput: $updateToolInventoryInput) {
      toolInventory {
        id
        isLocked
        onHandCount
        limitCount
        updatedDate
        updatedByUser {
          firstName
          lastName
        }
        updatedBy
      }
      errors
    }
  }
`;

export const UPDATE_BULK_TOOL_INVENTORY = gql`
  mutation BulkUpdateToolInventory($input: BulkUpdateToolInventoryInput!) {
    bulkUpdateToolInventory(input: $input) {
      toolInventoryItems {
        id
        onHandCount
        limitCount
        isLocked
        updatedBy
        updatedDate
        updatedByUser {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`;
